import Vue from 'vue'
import Vuex from 'vuex'

//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
const store = new Vuex.Store({
    state:{
        //存放的键值对就是所要管理的状态
        userName:'',
        password:'',
        engineerId:'',
        engineerSsoId:'',
        sectionId:'',
        sectionSsoId:'',
        workAreaId:'',
        mixplantId:'',
        mixplantName:'',
        // 当前选中拌合站关联作业面（与实时/后场查询保持一致）
        mixplantWorkAreaId:'',
        // 当前选中拌合站配比，后场 keyLabel 需要
        mixplantMixtureId:'',
        introduction:"",
        Participation:"",
        construction:"",
        supervisor:"",
        Design:"",
        mixplantOpen: false,
        fronCourOpen: false,
        hcCameraKey: '',
        seIds:""
    },
    mutations: {
        updataUserName(state,item) {
			state.userName = item
        },
        updataSeIds(state,item) {
			state.seIds = item
        },
        updataPassword(state,item) {
			state.password = item
        },
		updataEngineerId(state,item) {
			state.engineerId = item
        },
        updataEngineerSsoId(state,item) {
			state.engineerSsoId = item == null || item === '' ? '' : item
        },
        updataSectionId(state,item) {
			state.sectionId = item
        },
        updataSectionSsoId(state,item) {
			state.sectionSsoId = item == null || item === '' ? '' : item
        },
        updataWorkAreaId(state,item) {
			state.workAreaId = item
        },
        updataMixplantId(state,item) {
			state.mixplantId = item
        },
        updataMixplantName(state,item) {
			state.mixplantName = item
        },
        updataMixplantWorkAreaId(state,item) {
			state.mixplantWorkAreaId = item == null || item === '' ? '' : item
        },
        updataMixplantMixtureId(state,item) {
			state.mixplantMixtureId = item == null || item === '' ? '' : item
        },
        updataIntroduction(state,item) {
			state.introduction = item
        },
        updataParticipation(state,item) {
			state.Participation = item
        },
        updataConstruction(state,item) {
			state.construction = item
        },
        updataSupervisor(state,item) {
			state.supervisor = item
        },
        updataDesign(state,item) {
			state.Design = item
        },
        updataMixplantOpen(state,item) {
			state.mixplantOpen = item
        },
        updataFronCourOpen(state,item) {
			state.fronCourOpen = item
        },
        updataHcCameraKey(state, item) {
            state.hcCameraKey = item
        },
	}
})

export default store


// WEBPACK FOOTER //
// ./src/store/store.js